import { memo, type KeyboardEvent, type MouseEvent } from "react";
// Styles
import "./campaign-row.scss";
// Components
import { StatusChip } from "../../../../../../../../../../shared/components/status-chip/StatusChip";

interface Props {
	adsName: string;
	accountName: string;
	accountId: string;
	appId: string;
	status: string;
	cost: number;
	isNew: boolean;
  campaignId: number;
	onOpen?: (campaignId: string) => void;
}

export const CampaignRow = memo(
	({
		adsName,
		accountName,
		accountId,
		appId,
		status,
		cost,
    isNew,
		campaignId,
		onOpen,
	}: Props) => {
		const openCampaign = () => {
			onOpen?.(String(campaignId));
		};

		const handleClick = (e: MouseEvent) => {
			const target = e.target as HTMLElement;
			if (target.closest("[data-copyable]")) return;
			openCampaign();
		};

		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key === "Enter" || e.key === " ") {
				e.preventDefault();
				openCampaign();
			}
		};

		return (
			<div
				className='campaign-row campaign-row--clickable'
				role='button'
				tabIndex={0}
				onClick={handleClick}
				onKeyDown={handleKeyDown}
				aria-label={`Відкрити картку кампанії ${adsName}`}>
				<div className='campaign-row__wrapper'>
					<div className='campaign-row__name'>
						<div className='campaign-row__name-top'>
						<div className='campaign-row__name_ads break-text' data-copyable>
							{adsName}
						</div>
						{isNew && <span className='campaign-row__name_badge'>NEW</span>}
					</div>
						<div className='campaign-row__name-bottom'>
							<div
								className='campaign-row__name_title break-text'
								data-copyable>
								{accountName}
							</div>
							<div className='campaign-row__name_id break-text' data-copyable>
								{accountId}
							</div>
						</div>
					</div>
					<div className='campaign-row__app'>
						<div className='campaign-row__app_id break-text' data-copyable>
							{appId}
						</div>
					</div>
					<div className='campaign-row__status'>
						<StatusChip status={status} />
					</div>
					<div className='campaign-row__cost' data-copyable>
						<span data-copy-exclude>$</span>
						{Number(cost).toFixed(2)}
					</div>
				</div>
			</div>
		);
	},
);

CampaignRow.displayName = "CampaignRow";
